<template>
  <v-row no-gutters class="mb-2">
    <v-col cols="4" class="item-day">
      <v-row no-gutters align="center">
        <v-col cols="6">
          <v-menu
            v-model="menu"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="date"
                class="mt-0 pt-0"
                prepend-icon="icon-calendar"
                readonly
                hide-details
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              first-day-of-week="1"
              v-model="date"
              color="primary"
              :locale="selectedLocale"
              @input="menu = false"
            ></v-date-picker>
          </v-menu>
        </v-col>
        <v-col
          cols="6"
          class="d-flex align-center my-2"
          style="position: relative;"
        >
          <v-switch
            class="ml-4 mt-0 pb-1"
            color="primary"
            v-model="isOpen"
            @change="handleSwitch"
            hide-details
            inset
          ></v-switch>
          <span>
            {{
              isOpen ? $t("message.common.open") : $t("message.common.closed")
            }}
          </span>
          <v-btn
            v-if="!isOpen"
            icon
            absolute
            class="close-button"
            @click="$emit('remove-item', true)"
          >
            <v-icon>close</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-col>
    <v-col cols="5" class="item-hours">
      <template v-if="isOpen">
        <HoursPanel
          v-for="(hours, index) in formattedHours"
          :key="`special_hours-${day.name}${index}`"
          :hours="hours"
          :hoursRange="hoursRange"
          :hasButton="index > 0"
          @remove="handleRemove(index)"
          @hours="onHoursChange(index, $event)"
        />
      </template>
    </v-col>
    <v-col cols="3" class="item-actions">
      <ui-button color="secondary" @click="handleClick" :disabled="!isOpen">
        {{ $t("message.facilityDetails.addWorkingHours") }}
      </ui-button>
    </v-col>
  </v-row>
</template>

<script>
import HoursPanel from "@/components/FacilityDetails/Dialog/shared/ItemHoursPanel.vue";
import moment from "moment";
import { mapState } from "vuex";

export default {
  name: "SpecialHoursItem",
  components: {
    HoursPanel
  },
  props: {
    hoursRange: {
      type: Array,
      default: () => []
    },
    day: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      isOpen: !this.day.is_closed || false,
      date:
        moment(this.day.formatted_date).format("YYYY-MM-DD") ||
        moment().format("YYYY-MM-DD"),
      menu: false,
      formattedHours: this.day.value
    };
  },
  computed: {
    ...mapState({
      selectedLocale: state => state.settings.selectedLocale
    })
  },
  created() {
    this.$emit("trigger", this.formattedHours);
  },
  watch: {
    date(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.$emit("changedDate", newValue);
      }
    }
  },
  methods: {
    handleClick() {
      this.formattedHours.push(["", ""]);
      this.$emit("trigger", this.formattedHours);
    },
    handleRemove(index) {
      this.formattedHours.splice(index, 1);
      this.$emit("trigger", this.formattedHours);
    },
    handleSwitch(newValue) {
      this.isOpen = newValue;

      if (!this.isOpen) {
        this.formattedHours = this.day.value ? [...this.day.value] : [["", ""]];
      }

      this.$emit("switch", this.isOpen);
      this.$emit("trigger", this.formattedHours);
    },
    onHoursChange(index, { from, to }) {
      this.formattedHours[index] = [from, to];
      this.$emit("trigger", this.formattedHours);
    }
  }
};
</script>

<style lang="scss" scoped>
.item-day,
.item-hours,
.item-actions {
  display: flex;
  align-items: flex-start;
}

.item-actions {
  margin-top: 8px;
  justify-content: center;
}

.item-hours {
  flex-direction: column;
  margin-top: 8px;
  margin-bottom: 8px;
}

.item-day {
  padding-right: 60px;
}

.close-button {
  right: -60px;
}
</style>
